import { Marker } from "@react-google-maps/api";

import React from "react";

import * as PropTypes from "prop-types";
import { useTheme } from "styled-components";

import paths from "../../../Icon/paths/paths";

function MapMarkers(props) {
  const { markers, onMarkerClick, clusterer, markerIconUrl } = props;
  const theme = useTheme();

  const getIcon = () => {
    if (markerIconUrl) {
      return {
        // eslint-disable-next-line no-undef
        anchor: new google.maps.Point(16, 32),
        // eslint-disable-next-line no-undef
        scaledSize: new google.maps.Size(32, 32),
        url: markerIconUrl,
      };
    }

    return {
      // eslint-disable-next-line no-undef
      anchor: new google.maps.Point(9, 26),
      ariaLabel: "Map marker",
      fillColor: theme?.primaryColor || "#000000",
      fillOpacity: 1,
      path: paths.location.path[0],
      scale: 1.5,
      strokeColor: theme?.primaryColor || "#000000",
    };
  };

  return (
    <>
      {markers.map((markerObj, index) => (
        <Marker
          // eslint-disable-next-line react/no-array-index-key
          key={`${markerObj.id}-${index}`}
          clickable
          clusterer={clusterer}
          icon={getIcon()}
          onClick={() => onMarkerClick(markerObj)}
          position={markerObj.coords}
        />
      ))}
    </>
  );
}

MapMarkers.propTypes = {
  clusterer: PropTypes.shape({}),
  markerIconUrl: PropTypes.string,
  markers: PropTypes.arrayOf(
    PropTypes.shape({
      coords: PropTypes.shape({
        lat: PropTypes.number,
        lng: PropTypes.number,
      }),
      id: PropTypes.string,
    })
  ),
  onMarkerClick: PropTypes.func,
};

MapMarkers.defaultProps = {
  clusterer: undefined,
  markerIconUrl: undefined,
  markers: [],
  onMarkerClick: () => {},
};

export default MapMarkers;
